import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useId } from 'react';
import { unregisterKeyHandler } from '../structure/GlobalKeyHandler';
import { registerFrameHandler, unregisterFrameHandler } from '../helpers/animationFrame';
import './Drawer.css';
const doneState = { open: 'open', closed: 'closed', opening: 'open', closing: 'closed' };
const animDurationMs = 250;
function render(time, frameState) {
    if (!frameState.start) {
        frameState.start = time;
        return true;
    }
    const dt = time - frameState.start;
    const progress = Math.max(0, Math.min(animDurationMs, time - frameState.start)) / animDurationMs;
    const height = frameState.el.getBoundingClientRect().height;
    frameState.el.style.marginTop = (frameState.direction == 'opening' ? -height * (1 - progress) : -height * progress) + 'px';
    return dt < animDurationMs;
}
const Drawer = ({ open, initialOpen = false, children, onOpen, onClose }) => {
    const id = useId();
    const drawer = React.useRef(null);
    const [state, setState] = React.useState(initialOpen ? 'open' : 'closed');
    const [frameHandler, setFrameHandler] = React.useState(undefined);
    useEffect(() => {
        if (drawer.current) {
            if (state == 'opening' || state == 'closing') {
                const frameState = { direction: state, el: drawer.current };
                setFrameHandler(registerFrameHandler((t) => {
                    frameState.el.style.display = 'block';
                    if (!render(t, frameState)) {
                        setState(doneState[state]);
                        if (state == 'closing')
                            frameState.el.style.display = 'none';
                        else if (state == 'opening' && onOpen)
                            setTimeout(() => onOpen(), 1);
                        return false;
                    }
                    return true;
                }));
            }
            else if (state == 'closed')
                drawer.current.style.display = 'none';
            else if (state == 'open')
                drawer.current.style.display = 'block';
        }
        return () => {
            unregisterKeyHandler('expandable-' + id);
            unregisterFrameHandler(frameHandler);
        };
    }, [state, drawer.current]);
    useEffect(() => {
        if (open && (state == 'closed' || state == 'closing'))
            setState('opening');
        else if (!open && (state == 'open' || state == 'opening')) {
            setState('closing');
            if (onClose)
                onClose();
        }
    }, [open]);
    return (_jsx("div", { className: `drawerContainer ${state}`, children: _jsx("div", { ref: drawer, className: `drawer`, children: children }) }));
};
export default Drawer;
